import $ from 'jquery';

export default function partners() {
    const partners = $(".partners");

    partners.each(function () {
        const cards = $(this).find(".wp-block-media-text");

        cards.on('click', function (){
            const href = $(this).find('a').attr('href');

            window.location.href = href;
        })
    })
}